"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SharedBasesService", {
    enumerable: true,
    get: function() {
        return SharedBasesService;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _uuid = require("uuid");
const _config = require("@nestjs/config");
const _apphooksservice = require("~/services/app-hooks/app-hooks.service");
const _helpers = require("~/helpers");
const _catchError = require("~/helpers/catchError");
const _models = require("~/models");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
// todo: load from config
const config = {
    dashboardPath: '/nc'
};
let SharedBasesService = class SharedBasesService {
    async createSharedBaseLink(context, param) {
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/SharedBaseReq', param);
        const base = await _models.Base.get(context, param.baseId);
        let roles = param == null ? void 0 : param.roles;
        if (!roles || roles !== 'editor' && roles !== 'viewer') {
            roles = 'viewer';
        }
        if (roles === 'editor') {
            _catchError.NcError.badRequest('Only viewer role is supported');
        }
        if (!base) {
            _catchError.NcError.baseNotFound(param.baseId);
        }
        const data = {
            uuid: (0, _uuid.v4)(),
            password: param == null ? void 0 : param.password,
            roles
        };
        await _models.Base.update(context, base.id, data);
        data.url = this.getUrl({
            base,
            siteUrl: param.siteUrl
        });
        delete data.password;
        this.appHooksService.emit(_nocodbsdk.AppEvents.SHARED_BASE_GENERATE_LINK, {
            link: data.url,
            base,
            req: param.req,
            uuid: data.uuid,
            sharedBaseRole: roles,
            context: _extends({}, context)
        });
        return data;
    }
    async updateSharedBaseLink(context, param) {
        var _ref;
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/SharedBaseReq', param);
        const base = await _models.Base.get(context, param.baseId);
        let roles = param.roles;
        if (!roles || roles !== 'editor' && roles !== 'viewer') {
            roles = 'viewer';
        }
        if (!base) {
            _catchError.NcError.baseNotFound(param.baseId);
        }
        if (roles === 'editor' && process.env.NC_CLOUD === 'true') {
            _catchError.NcError.badRequest('Only viewer role is supported');
        }
        let customUrl = base.fk_custom_url_id ? await _models.CustomUrl.get({
            id: base.fk_custom_url_id
        }) : undefined;
        // Update an existing custom URL if it exists
        if (customUrl == null ? void 0 : customUrl.id) {
            const original_path = `/base/${base.uuid}`;
            if (param.custom_url_path) {
                // Prepare updated fields conditionally
                const updates = {
                    original_path
                };
                if (param.custom_url_path !== undefined) {
                    updates.custom_path = param.custom_url_path;
                }
                // Perform the update if there are changes
                if (Object.keys(updates).length > 0) {
                    await _models.CustomUrl.update(base.fk_custom_url_id, updates);
                }
            } else if (param.custom_url_path !== undefined) {
                // Delete the custom URL if only the custom path is undefined
                await _models.CustomUrl.delete({
                    id: base.fk_custom_url_id
                });
                customUrl = undefined;
            }
        } else if (param.custom_url_path) {
            // Insert a new custom URL if it doesn't exist
            const original_path = `/base/${base.uuid}`;
            customUrl = await _models.CustomUrl.insert({
                fk_workspace_id: base.fk_workspace_id,
                base_id: base.id,
                original_path,
                custom_path: param.custom_url_path
            });
        }
        const data = {
            uuid: base.uuid || (0, _uuid.v4)(),
            password: param.password,
            roles,
            fk_custom_url_id: (_ref = customUrl == null ? void 0 : customUrl.id) != null ? _ref : null
        };
        await _models.Base.update(context, base.id, data);
        data.url = this.getUrl({
            base,
            siteUrl: param.siteUrl
        });
        delete data.password;
        this.appHooksService.emit(_nocodbsdk.AppEvents.SHARED_BASE_GENERATE_LINK, {
            link: data.url,
            base,
            req: param.req,
            sharedBaseRole: roles,
            context,
            uuid: data.uuid,
            customUrl
        });
        return data;
    }
    getUrl({ base, siteUrl: _siteUrl }) {
        let siteUrl = _siteUrl;
        const baseDomain = process.env.NC_BASE_HOST_NAME;
        const dashboardPath = this.configService.get('dashboardPath', {
            infer: true
        });
        if (baseDomain) {
            siteUrl = `https://${base['fk_workspace_id']}.${baseDomain}${dashboardPath}`;
        }
        return `${siteUrl}${config.dashboardPath}#/base/${base.uuid}`;
    }
    async disableSharedBaseLink(context, param) {
        const base = await _models.Base.get(context, param.baseId);
        if (!base) {
            _catchError.NcError.baseNotFound(param.baseId);
        }
        const data = {
            uuid: null,
            fk_custom_url_id: null
        };
        await _models.Base.update(context, base.id, data);
        if (base.fk_custom_url_id) {
            await _models.CustomUrl.delete({
                id: base.fk_custom_url_id
            });
        }
        this.appHooksService.emit(_nocodbsdk.AppEvents.SHARED_BASE_DELETE_LINK, {
            base,
            req: param.req,
            context,
            uuid: base.uuid
        });
        return {
            uuid: null
        };
    }
    async getSharedBaseLink(context, param) {
        const base = await _models.Base.get(context, param.baseId);
        if (!base) {
            _catchError.NcError.baseNotFound(param.baseId);
        }
        const data = {
            uuid: base.uuid,
            roles: base.roles,
            fk_custom_url_id: base.fk_custom_url_id
        };
        if (data.uuid) data.url = `${param.siteUrl}${config.dashboardPath}#/base/${data.shared_base_id}`;
        return data;
    }
    constructor(appHooksService, configService){
        this.appHooksService = appHooksService;
        this.configService = configService;
    }
};
SharedBasesService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _apphooksservice.AppHooksService === "undefined" ? Object : _apphooksservice.AppHooksService,
        typeof _config.ConfigService === "undefined" ? Object : _config.ConfigService
    ])
], SharedBasesService);
